import sendRequest from '../client/sendRequest';

const BASE_URL = '/api/blogPostAuthors';

/* ---------- Get ---------- */

// Get all Blog post authors
export async function getAllAuthors() {
  return await sendRequest(BASE_URL, 'GET');
}

// Get all Blog post authors with post count
export async function getAllAuthorsWithPostCount() {
  return await sendRequest(`${BASE_URL}/with-counts`, 'GET');
}

// Get blog post author by slug with blog posts
export async function getAuthorBySlugWithBlogPosts(slug, { filter = {} }) {
  const query = new URLSearchParams({
    ...filter,
  }).toString();

  return await sendRequest(`${BASE_URL}/${slug}?${query}`, 'GET');
}

// Get blog post author by slug with blog page posts
export const getAuthorBySlugWithBlogPagePosts = (slug) =>
  getAuthorBySlugWithBlogPosts(slug, { filter: { showOnBlog: true } });

/* ---------- Create ---------- */

// Create a Blog post author
export async function createAuthor(data) {
  return await sendRequest(BASE_URL, 'POST', data);
}

/* ---------- Update ---------- */

// Edit a Blog post author
export async function updateAuthor(id, data) {
  return await sendRequest(`${BASE_URL}/${id}`, 'PUT', data);
}

/* ---------- Delete ---------- */

//Delete a Blog post author
export async function deleteAuthor(id) {
  return await sendRequest(`${BASE_URL}/${id}`, 'DELETE');
}
